export enum SurveyStatuses {
  notStarted = 0,
  demographics = 10,
  introduction = 20,
  indicatorQuestions = 30,
  effectivenessQuestions = 40,
  commentsQuestions = 50,
  finalWords = 60,
  completeSurvey = 70
}
